import { render, staticRenderFns } from "./Radiobutton.vue?vue&type=template&id=1bd3447e"
import script from "./Radiobutton.vue?vue&type=script&lang=js"
export * from "./Radiobutton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports